import * as Yup from "yup";

export const NewMappingValidation = Yup.object().shape({
    category: Yup.string().required(
      "Select Good Stock Category to create mapping"
    ),
    gwp_sku_item: Yup.string().required("Select GWP SKU to create mapping"),
    good_stock_sku_item: Yup.string().required(
      "Select Good Stock SKU to create mapping"
    ),
  });